<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M5.93262 15.376C5.93262 15.376 7.43262 15.376 9.43262 18.876C9.43262 18.876 14.9914 9.70931 19.9326 7.87598"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>